import { render } from "./Packages.vue?vue&type=template&id=6e1f00ea&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6e1f00ea"

export default script